import {variables} from '../Variables.json'
export var validations = {
    profilePicUpload : (data) =>{
        console.log(data)
        if(data.length > 0){
            if(data[0].size <= variables.limit.Profile.sellerPic){
                return {"status":true,"msg":"success"}
            }
            else{
                return {"status":false,"msg":"Please upload image of size less than or equal to 2 Mb."}
            }
        }
    }
}